<template>
  <div
    class="top-navbar d-flex justify-content-between align-items-center px-4 py-3 bg-white shadow-sm"
  >
    <div class="d-flex align-items-center gap-2">
      <button
        class="btn btn-light rounded shadow-sm icon-btn d-md-none"
        @click="$emit('toggle-sidebar')"
      >
        <i class="bi bi-list fs-5"></i>
      </button>
      <div class="fw-bold fs-5">ARKIFY POS</div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <button
        class="btn btn-light rounded shadow-sm icon-btn"
        @click="toggleFullscreen()"
      >
        <i class="bi bi-arrows-fullscreen fs-5"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavbarComponent",
  emits: ["toggle-sidebar"],
  computed: {
    ...mapGetters("auth", ["authUser"]),
  },
  methods: {
    toggleFullscreen() {
      const el = document.documentElement;
      if (!document.fullscreenElement) {
        el.requestFullscreen?.();
      } else {
        document.exitFullscreen?.();
      }
    },
  },
};
</script>

<style scoped>
.top-navbar {
  height: 70px;
}

.icon-btn {
  width: 44px;
  height: 44px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
